import mixpanel from 'mixpanel-browser';

const API_TOKEN = process.env.NX_MIXPANEL_PROJECT_TOKEN;

declare global {
  interface Window {
    pendo: any;
    heap?: {
      track: (event: string, properties?: Record<string, unknown>) => void;
      identify: (identity: string) => void;
      resetIdentity: () => void;
      addUserProperties: (properties: Record<string, any>) => void;
      addEventProperties: (properties: Record<string, any>) => void;
      removeEventProperty: (property: string) => void;
      clearEventProperties: () => void;
      appid: string;
      loaded: boolean;
      userId: string;
      identity: string | null;
      config: any;
    };
  }
}

function isProduction() {
  return process.env.NX_ENV === 'production';
}

mixpanel.init(API_TOKEN, {
  debug: process.env.NX_ENV === 'development',
  persistence: 'localStorage',
});

function track(...args: Parameters<typeof mixpanel.track>) {
  if (API_TOKEN) {
    mixpanel.track(...args);
  }
}

function identify(...args: Parameters<typeof mixpanel.identify>) {
  if (API_TOKEN) {
    mixpanel.identify(...args);
  }
}

function reset() {
  if (API_TOKEN) {
    mixpanel.reset();
  }
}

function trackPageView() {
  if (API_TOKEN) {
    mixpanel.track_pageview();
  }
}

export const analytics = {
  identify,
  reset,
  trackPageView,
  track,
};

export const pendo = {
  isReady: () => {
    if (isProduction()) {
      return window.pendo?.isReady?.();
    }
  },
  isAnonymousVisitor: () => {
    if (isProduction()) {
      return window.pendo?.isAnonymousVisitor?.();
    }
  },
  initializeAnonymous: () => {
    if (isProduction()) {
      window.pendo?.initialize?.({
        visitor: {
          id: 'VISITOR-UNIQUE-ID',
        },
      });
    }
  },
  initializeAuthenticated: (email: string, tenantDisplayName?: string) => {
    if (isProduction()) {
      window.pendo?.initialize?.({
        visitor: {
          id: email,
        },

        account: {
          id: tenantDisplayName,
        },
      });
    }
  },
  identify: (email: string, tenantDisplayName?: string) => {
    if (isProduction()) {
      window.pendo?.identify({
        visitor: {
          id: email,
        },

        account: {
          id: tenantDisplayName,
        },
      });
    }
  },
  trackPageView: (page: string, user?: string) => {
    if (isProduction()) {
      window.pendo?.track(page, {
        user: user,
      });
    }
  },

  track: (eventName: string, trackingInformation: Record<string, unknown>) => {
    if (isProduction()) {
      window.pendo?.track(eventName, trackingInformation);
    }
  },
};

export const heap = {
  identify: (user: string) => {
    if (isProduction()) {
      try {
        if (window.heap.loaded) {
          window.heap?.identify(user);
        }
      } catch (e) {
        console.error('Error in heap.identify: ', e);
      }
    }
  },

  trackPageView: (page: string, user?: string) => {
    if (isProduction()) {
      try {
        if (window.heap.loaded) {
          window.heap?.track(page, { user });
        }
      } catch (e) {
        console.error('Error in heap.trackPageView: ', e);
      }
    }
  },
};
